export const templateIdMap = {
  video: 'dbffdcf8566a4b4abdac79abce7b8a31', // 新 1080p 模板
  audio: 'd9aabd3810584a70bc31264130e63e9a',
};
export default templateIdMap;
// video: '2b6624a4dbf943efbe174b2d9ba5849b', // 旧 480p 模板
